(function () {
  function money(cents, format, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function productImage(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    return image ? '<img class="ufm-recommended-together__image" src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span class="ufm-recommended-together__image">No image</span>';
  }

  function stockDetails(variant) {
    var inventory = Number(variant.inventory_quantity);
    var hasInventory = variant.inventory_quantity !== null && variant.inventory_quantity !== undefined && variant.inventory_quantity !== '' && Number.isFinite(inventory);
    if (variant.inventory_management === 'shopify' && hasInventory) {
      if (inventory > 0) return { text: inventory + ' in stock', state: 'in' };
      if (variant.inventory_policy === 'continue') return { text: 'Available to order', state: 'order' };
      return { text: 'Out of stock', state: 'out' };
    }
    return variant.available === true ? { text: 'Available', state: 'in' } : { text: 'Out of stock', state: 'out' };
  }

  function canSelect(variant) {
    var inventory = Number(variant.inventory_quantity);
    var hasInventory = variant.inventory_quantity !== null && variant.inventory_quantity !== undefined && variant.inventory_quantity !== '' && Number.isFinite(inventory);
    if (variant.inventory_management === 'shopify' && hasInventory) return inventory > 0 || variant.inventory_policy === 'continue';
    return variant.available === true;
  }

  function setStockElement(element, details) {
    if (!element) return;
    element.dataset.stockState = details.state;
    element.innerHTML = '<span class="ufm-stock-dot ufm-stock-dot--' + (details.state === 'out' ? 'unavailable' : 'available') + '"></span><span>' + escapeHtml(details.text) + '</span>';
  }

  function enrichProduct(product) {
    if (!product.handle) return Promise.resolve(product);
    return fetch('/products/' + encodeURIComponent(product.handle))
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return product;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inventoryScript = parsed.querySelector('[data-ufm-inventory-map]');
        var inventoryMap = inventoryScript ? JSON.parse(inventoryScript.textContent) : {};
        product.variants = (product.variants || []).map(function (variant) {
          var inventoryVariant = inventoryMap[String(variant.id)];
          return inventoryVariant ? Object.assign({}, variant, inventoryVariant) : variant;
        });
        return product;
      })
      .catch(function () { return product; });
  }

  function init(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-ufm-recommended-together]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll('[data-ufm-recommended-together]')));
    roots.forEach(function (root) {
      if (root.dataset.ufmRecommendedReady === 'true') return;
      root.dataset.ufmRecommendedReady = 'true';
      var form = root.querySelector('[data-ufm-recommended-form]');
      var items = root.querySelector('[data-ufm-recommended-items]');
      var summaryTotal = root.querySelector('[data-ufm-recommended-total]');
      var summaryCount = root.querySelector('[data-ufm-recommended-count]');
      var submit = root.querySelector('[data-ufm-recommended-submit]');
      var status = root.querySelector('[data-ufm-recommended-status]');
       var format = root.dataset.moneyFormat || '{{amount}}';
      var currency = root.dataset.currency || 'GBP';
      var mainForm = document.querySelector(root.dataset.mainForm);
      var mainVariantField = mainForm && mainForm.querySelector('[name="id"]');
      var mainQuantity = mainForm && mainForm.querySelector('[name="quantity"]');
      var main = root.querySelector('[data-ufm-recommended-main]');

      function quantity() {
        var value = parseInt(mainQuantity && mainQuantity.value, 10);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      function priceMarkup(variant, each) {
         var current = money(Number(variant.price || 0), format, currency);
         var compare = Number(variant.compare_at_price || 0) > Number(variant.price || 0) ? '<s>' + money(Number(variant.compare_at_price), format, currency) + '</s> ' : '';
         return compare + '<strong>' + current + ' <small class="price-vat-label">Inc VAT</small></strong>' + (each ? ' <small>each</small>' : '');
      }

      function updateMain() {
        if (!mainVariantField || !main) return;
        var variants = window.ufmRecommendedMainVariants || [];
        var data = variants.find(function (entry) { return String(entry.id) === String(mainVariantField.value); });
        if (!data) return;
        main.dataset.variantId = data.id;
        main.dataset.priceInc = data.price;
        main.dataset.comparePriceInc = data.compare_at_price || 0;
        main.dataset.available = data.available;
        var price = main.querySelector('[data-ufm-main-price]');
        if (price) price.innerHTML = priceMarkup(data, false);
        var image = main.querySelector('.ufm-recommended-together__image');
        if (image && data.image) image.src = data.image;
        updateTotal();
      }

      function updateTotal() {
        var total = 0;
        var count = 0;
        var mainCheckbox = main && main.querySelector('input[type="checkbox"]');
        if (mainCheckbox && mainCheckbox.checked) { total += Number(main.dataset.priceInc || 0) * quantity(); count += quantity(); }
        Array.from(root.querySelectorAll('[data-ufm-recommended-item]:not([data-ufm-recommended-main])')).forEach(function (item) {
          var checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked && !checkbox.disabled) { total += Number(item.dataset.priceInc || 0); count += 1; }
        });
        var mainAvailable = mainCheckbox && mainCheckbox.checked ? main.dataset.available === 'true' : true;
        var selectedUnavailable = Array.from(root.querySelectorAll('input[type="checkbox"]')).some(function (checkbox) { return checkbox.checked && checkbox.disabled; });
        summaryCount.textContent = 'Total (' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
         summaryTotal.textContent = money(total, format, currency);
        submit.textContent = 'Add all ' + count + ' to basket';
        submit.disabled = !count || !mainAvailable || selectedUnavailable;
      }

      function renderProduct(product) {
        var variants = product.variants || [];
        var selected = variants.find(function (variant) { return canSelect(variant); }) || variants[0];
        if (!selected) return '';
        var options = variants.length > 1 ? '<select data-ufm-recommended-variant aria-label="Choose an option for ' + escapeHtml(product.title) + '">' + variants.map(function (variant) {
          var available = canSelect(variant);
          return '<option value="' + escapeHtml(variant.id) + '" data-price-inc="' + Number(variant.price || 0) + '" data-compare-price-inc="' + Number(variant.compare_at_price || 0) + '" data-sku="' + escapeHtml(variant.sku) + '" data-available="' + available + '" data-inventory-management="' + escapeHtml(variant.inventory_management) + '" data-inventory-quantity="' + escapeHtml(variant.inventory_quantity) + '" data-inventory-policy="' + escapeHtml(variant.inventory_policy) + '"' + (String(variant.id) === String(selected.id) ? ' selected' : '') + '>' + escapeHtml(variant.title) + (available ? '' : ' - Out of stock') + '</option>';
        }).join('') + '</select>' : '';
        var stock = stockDetails(selected);
        return '<article class="ufm-recommended-together__item' + (canSelect(selected) ? '' : ' is-unavailable') + '" data-ufm-recommended-item data-product-id="' + product.id + '" data-variant-id="' + selected.id + '" data-price-inc="' + Number(selected.price || 0) + '">' +
          '<div class="ufm-recommended-together__image-wrap"><a href="/products/' + escapeHtml(product.handle) + '">' + productImage(product) + '</a></div>' +
          '<div class="ufm-recommended-together__check"><input type="checkbox" data-ufm-recommended-checkbox aria-label="Select ' + escapeHtml(product.title) + '"' + (canSelect(selected) ? '' : ' disabled') + '></div>' +
          '<div class="ufm-recommended-together__body"><h3>' + escapeHtml(product.title) + '</h3>' +
          '<ufm-card-reviews class="ufm-card-reviews" data-product-id="' + escapeHtml(product.id) + '" hidden><span data-ufm-card-score hidden></span><span data-ufm-card-stars role="img" aria-label="No customer ratings yet"><span data-ufm-card-stars-fill aria-hidden="true"></span></span><a href="/products/' + escapeHtml(product.handle) + '#ufm-product-reviews" data-ufm-card-count></a></ufm-card-reviews>' +
          '<a class="ufm-recommended-together__view" href="/products/' + escapeHtml(product.handle) + '">↗ View product</a>' + options + '<div class="ufm-recommended-stock" data-ufm-recommended-stock data-stock-state="' + stock.state + '"><span class="ufm-stock-dot ufm-stock-dot--' + (stock.state === 'out' ? 'unavailable' : 'available') + '"></span><span>' + escapeHtml(stock.text) + '</span></div></div>' +
          '<p class="ufm-recommended-together__price"><span data-ufm-recommended-price>' + priceMarkup(selected, true) + '</span></p></article>';
      }

      function updateItem(item) {
        var select = item.querySelector('[data-ufm-recommended-variant]');
        var option = select && select.options[select.selectedIndex];
        if (!option) return;
        var variant = { available: option.dataset.available === 'true', inventory_management: option.dataset.inventoryManagement, inventory_quantity: option.dataset.inventoryQuantity, inventory_policy: option.dataset.inventoryPolicy, price: Number(option.dataset.priceInc), compare_at_price: Number(option.dataset.comparePriceInc) };
        var available = canSelect(variant);
        item.dataset.variantId = option.value;
        item.dataset.priceInc = variant.price;
        item.classList.toggle('is-unavailable', !available);
        var checkbox = item.querySelector('input[type="checkbox"]');
        checkbox.disabled = !available;
        if (checkbox.disabled) checkbox.checked = false;
        item.querySelector('[data-ufm-recommended-price]').innerHTML = priceMarkup(variant, true);
        setStockElement(item.querySelector('[data-ufm-recommended-stock]'), stockDetails(variant));
      }

      if (mainQuantity) mainQuantity.addEventListener('change', updateTotal);
      if (mainVariantField) mainVariantField.addEventListener('change', updateMain);
      fetch(root.dataset.recommendationsUrl + '?product_id=' + root.dataset.productId + '&limit=' + root.dataset.maxProducts + '&intent=complementary')
        .then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (product) { return String(product.id) !== String(root.dataset.productId); }).slice(0, Number(root.dataset.maxProducts));
          if (!products.length) return;
          return Promise.all(products.map(enrichProduct)).then(function (enriched) { items.insertAdjacentHTML('beforeend', enriched.map(renderProduct).join('')); });
        })
        .then(function () { if (items.querySelector('[data-ufm-recommended-item]:not([data-ufm-recommended-main])')) { root.hidden = false; updateTotal(); } })
        .catch(function () {});

      root.addEventListener('change', function (event) {
        var item = event.target.closest('[data-ufm-recommended-item]');
        if (item && event.target.matches('[data-ufm-recommended-variant]')) updateItem(item);
        updateTotal();
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var mainCheckbox = main.querySelector('input[type="checkbox"]');
        var cartItems = [];
        if (mainCheckbox.checked) cartItems.push({ id: Number(main.dataset.variantId), quantity: quantity() });
        Array.from(root.querySelectorAll('[data-ufm-recommended-item]:not([data-ufm-recommended-main])')).forEach(function (item) { var checkbox = item.querySelector('input[type="checkbox"]'); if (checkbox.checked && !checkbox.disabled) cartItems.push({ id: Number(item.dataset.variantId), quantity: 1 }); });
        if (!cartItems.length) return;
        submit.disabled = true; submit.textContent = 'Adding...'; status.hidden = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: cartItems, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) })
          .then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Unable to add selected products.'); return data; }); })
          .then(function (state) { var drawer = document.querySelector('cart-drawer'); if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state); else window.location.href = '/cart'; })
          .catch(function (error) { status.textContent = error.message; status.hidden = false; updateTotal(); })
          .finally(function () { updateTotal(); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
